import type { aquaman } from '@/product-discovery/types/generated/aquaman';

export function filterStores(
  stores: Array<aquaman.StoreDetailsModel>,
  { query }: { query: string },
) {
  const q = query.toLowerCase().trim();

  if (!q) {
    return stores;
  }

  return stores.filter((store) => {
    const name = store.name.toLowerCase();
    const city = store.address?.city?.toLowerCase() ?? '';
    const region = store.address?.region?.toLowerCase() ?? '';

    return name.includes(q) || city.includes(q) || region.includes(q);
  });
}
